import { useCallback, useContext, useEffect, useMemo, useState } from 'react'
import { metodoPrograma } from '../../../../../../components/api'
import { GlobalContext } from '../../../../../../App'
import { MenuItem, Paper, Popper, TextField } from '@mui/material'

export const PacienteInput = ({ setValue, register, watch, errors }) => {
  const { localAtendimento } = useContext(GlobalContext)
  const [pacientes, setPacientes] = useState([])
  const [anchorEl, setAnchorEl] = useState(null)
  const dsAgendamento = watch('dsAgendamento')

  const pacientesFiltrados = useMemo(() => {
    const busca = dsAgendamento.trim().toLowerCase()
    const buscaSemFormato = busca.replace(/\D/g, '')
    const buscaNumero =
      buscaSemFormato && !isNaN(Number(buscaSemFormato))
        ? buscaSemFormato
        : null
    return pacientes
      .filter((paciente) => {
        const nomePaciente = paciente[1]?.toLowerCase()
        const cpfPaciente = paciente[2]?.replace(/\D/g, '')

        if (buscaNumero && cpfPaciente) {
          return cpfPaciente.includes(buscaNumero)
        }

        return nomePaciente.includes(busca)
      })
      .slice(0, 15)
  }, [pacientes, dsAgendamento])

  const getList = useCallback(async () => {
    const result = await metodoPrograma(
      'lista',
      {
        idLocalAtendimento: localAtendimento[0],
      },
      'CtrlPaciente',
    )
    if (result.status) {
      setPacientes(result.lista)
    }
  }, [localAtendimento])

  const handleOpenOptions = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget)
  }

  const handleSelectOption = (value) => {
    if (!value || value.length < 8) return
    setValue('idPaciente', value[0])
    setValue('dsAgendamento', value[1])
    setValue('cdCpf', value[2])
    setValue('nrTelefone', value[6])
    setValue('dsEmail', value[7])
  }

  const handleBlur = () => {
    setTimeout(() => {
      setAnchorEl(null)
    }, 200)
  }

  useEffect(() => {
    getList()
  }, [getList])

  return (
    <div className="w-full flex flex-col">
      <div className="w-full flex items-end">
        <TextField
          {...register('dsAgendamento')}
          fullWidth
          label="Paciente ou CPF"
          variant="outlined"
          margin="dense"
          onFocus={handleOpenOptions}
          value={watch('dsAgendamento')}
          autoComplete="off"
          onBlur={handleBlur}
          size="small"
          aria-autocomplete="list"
          aria-expanded={Boolean(anchorEl)}
          aria-controls="paciente-options"
          onChange={(e) => {
            setValue('dsAgendamento', e.target.value)
            setValue('idPaciente', null)
            setValue('cdCpf', '')
            setValue('dsEmail', '')
            setValue('nrTelefone', '')
          }}
        />
        <Popper
          style={{
            zIndex: 2000,
            maxHeight: '200px',
            overflowY: 'auto',
            minWidth: anchorEl ? anchorEl.offsetWidth : '200px',
          }}
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          disablePortal
        >
          <Paper style={{ width: '100%' }}>
            {pacientesFiltrados.map((option) => (
              <MenuItem
                key={option[0]}
                id={`paciente-option-${option[0]}`}
                onClick={() => handleSelectOption(option)}
              >
                {option[1]}
              </MenuItem>
            ))}
          </Paper>
        </Popper>
      </div>
      {errors.idPaciente && (
        <span className="text-red-500 text-xs">
          {errors.idPaciente.message}
        </span>
      )}
    </div>
  )
}
